import { t } from 'state/intl/translations';

/**
 * Why an unavailable offer needs recovery-specific explanatory copy.
 *
 * The reason travels back to the offers feed as a route param so the pinned
 * card can explain itself while preserving the restaurant-selection CTA.
 */
export const UNAVAILABLE_OFFER_REASON = {
  /** The offer's store restriction excludes every nearby restaurant. */
  NO_NEARBY_STORES: 'NO_NEARBY_STORES',
} as const;

export type UnavailableOfferReason = typeof UNAVAILABLE_OFFER_REASON[keyof typeof UNAVAILABLE_OFFER_REASON];

export function parseUnavailableOfferReason(value: string): UnavailableOfferReason | undefined {
  return value === UNAVAILABLE_OFFER_REASON.NO_NEARBY_STORES ? value : undefined;
}

export function resolveUnavailableOfferReasonMessage(
  reason?: UnavailableOfferReason
): string | undefined {
  return reason === UNAVAILABLE_OFFER_REASON.NO_NEARBY_STORES
    ? t('offerNotAvailableNearYou', 'This offer is not available near you')
    : undefined;
}
